import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const External14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 2.75H6V1.25H2.5C1.80964 1.25 1.25 1.80964 1.25 2.5V11.5C1.25 12.1904 1.80964 12.75 2.5 12.75H11.5C12.1904 12.75 12.75 12.1904 12.75 11.5V8H11.25V11.25H2.75V2.75Z'
      fill='currentColor'
    />
    <path
      d='M11.25 3.81071L6.03039 9.03033L4.96973 7.96967L10.1894 2.75H9V1.25H12.75V5H11.25V3.81071Z'
      fill='currentColor'
    />
  </Svg>
);

External14.displayName = 'External14';
export default External14;
